/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
import './bootstrap'
import React from 'react'
import { render } from 'react-dom'
import AdminApp from './admin-app'
import LoginApp from './login-app'
import API from './admin-app/services/API'
import { ConfigProvider } from 'antd'
import esES from 'antd/es/locale/es_ES'

if (document.getElementById('admin-app')) {
    const el = document.getElementById('admin-app')
    const props = Object.assign({}, el.dataset)
    if (props.user) {
        props.user = JSON.parse(props.user)
    }
    if (props.token) {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + props.token
    }
    console.log(process,'proces')
    window.app_url = process.env.APP_URL

    render(
        <ConfigProvider locale={esES}>
            <AdminApp {...props} />
        </ConfigProvider>,
        el
    )
}

if (document.getElementById('login-app')) {
    render(<LoginApp />, document.getElementById('login-app'))
}
